import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M17.14 6.86c.86.86.86 3.43 1.71 3.43s.86-2.57 1.71-3.43c.85-.86 3.43-.86 3.43-1.71s-2.57-.86-3.43-1.71C19.7 2.59 19.7.01 18.85.01s-.86 2.57-1.71 3.43c-.85.86-3.43.86-3.43 1.71s2.57.86 3.43 1.71ZM17.14 12c0-.86-2.96-1.24-5.14-3.43C9.82 6.38 9.43 0 8.57 0c-.86 0-1.29 6.43-3.43 8.57C3 10.71 0 11.14 0 12c0 .86 2.96 1.24 5.14 3.43C7.32 17.62 7.71 24 8.57 24c.86 0 1.29-6.43 3.43-8.57 2.14-2.14 5.14-2.57 5.14-3.43ZM20.57 17.14c-.86-.86-.86-3.43-1.71-3.43s-.86 2.57-1.71 3.43c-.85.86-3.43.86-3.43 1.71s2.57.86 3.43 1.71c.86.85.86 3.43 1.71 3.43s.86-2.57 1.71-3.43c.85-.86 3.43-.86 3.43-1.71s-2.57-.86-3.43-1.71Z" />
  </>
);

const CollHiddenGems = Icon('coll-hidden-gems', svgContents);

export default CollHiddenGems;
